import React, { Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingSpinner from '../shared/LoadingSpinner';

interface ProtectedRouteProps {
  element: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Kullanıcı giriş yapmadıysa, giriş sayfasına yönlendir ve mevcut sayfayı state'e kaydet
    return <Navigate to="/yonetim/giris" state={{ from: location }} replace />;
  }

  // Authenticated kullanıcı için sayfayı Suspense ile sarmala
  return <Suspense fallback={<LoadingSpinner />}>{element}</Suspense>;
};

export default ProtectedRoute;